import { api } from "./api";

export const librariesList = async (addUrl = ``) => {
  return await api.get(`/library/list?${addUrl}`);
};

export const libraryAdd = async (data) => {
  return await api.post(`/library/add`, data);
};

export const libraryUpdate = async (data) => {
  return await api.post(`/library/update`, data);
};

export const libraryDelete = async (id) => {
  return await api.get(`/library/delete?id=${id}`);
};

export const libraryStatusChange = async (id) => {
  return await api.get(`/library/status/change?id=${id}`);
};

export const libraryShiftsList = async (addUrl = "") => {
  let url = `/library/shift/list?${addUrl}`;
  return await api.get(url);
};

export const libraryShiftAdd = async (data) => {
  return await api.post(`/library/shift/add`, data);
};

export const libraryShiftDelete = async (id) => {
  return await api.get(`/library/shift/delete?id=${id}`);
};

export const libraryShiftUpdate = async (data) => {
  return await api.post(`/library/shift/update`, data);
};

export const libraryShiftStatusChange = async (id) => {
  return await api.post(`/library/shift/status/change`, { id });
};

export const libraryVacantSeatsList = async (addUrl = "") => {
  let url = `/library/vacant/seat/list?${addUrl}`;
  return await api.get(url);
};

export const librarySeatsList = async (addUrl = "") => {
  let url = `/library/seat/list?${addUrl}`;
  return await api.get(url);
};

export const librarySeatAdd = async (data) => {
  return await api.post(`/library/seat/add`, data);
};

export const librarySeatDelete = async (id) => {
  return await api.get(`/library/seat/delete?id=${id}`);
};

export const librarySeatUpdate = async (data) => {
  return await api.post(`/library/seat/update`, data);
};

export const librarySeatStatusChange = async (data) => {
  return await api.post(`/library/seat/status/change`, data);
};

export const libraryStudentList = async (addUrl = "") => {
  return await api.get(`/library/student/list?${addUrl}`);
};

export const libraryStudentAdd = async (data) => {
  return await api.post(`/library/student/add`, data);
};

export const libraryStudentDelete = async (id) => {
  return await api.get(`/library/student/delete?id=${id}`);
};

export const libraryStudentStatusChange = async (id, end_date) => {
  return await api.get(
    `/library/student/status/change?id=${id}&end_date=${end_date}`,
  );
};

export const libraryStudentView = async (id) => {
  return await api.get(`/library/student/view?id=${id}`);
};

export const libraryStudentUpdate = async (data) => {
  return await api.post(`/library/student/update`, data);
};

export const libraryStudentTestReport = async (id) => {
  return await api.get(`/library/student/test-report/${id}`);
};

export const libraryFeeCollection = async (addUrl = "") => {
  return await api.get(`/library/fee-collection?${addUrl}`);
};

export const libraryFeeDepositInfo = async (addUrl = "") => {
  return await api.get(`/library/fee/deposit/info?${addUrl}`);
};

export const libraryFeeDeposit = async (data) => {
  return await api.post(`/library/fee/deposit`, data);
};

export const libraryFeeReceipt = async (id) => {
  return await api.get(`/library/fee/receipt?id=${id}`);
};

export const libraryFeeDepositInfov2 = async (addUrl = "") => {
  return await api.get(`/library/fee/deposit/info/v2?${addUrl}`);
};

export const libraryFeeDepositv2 = async (data) => {
  return await api.post(`/library/fee/deposit/v2`, data);
};

export const libraryFeeReceiptv2 = async (id) => {
  return await api.get(`/library/fee/receipt/v2?id=${id}`);
};

export const libraryFeeUpdateStudent = async (data) => {
  return await api.post(`/library/fee/update/student`, data);
};

export const libraryFeeUpdateMonth = async (data) => {
  return await api.post(`/library/fee/update/month`, data);
};

// ── Dashboard / report endpoints ───────────────────────────────

export const libraryDashboardStats = async (addUrl = "") => {
  return await api.get(`/library/report/dashboard-stats?${addUrl}`);
};

export const libraryMonthlyCollectionReport = async (addUrl = "") => {
  return await api.get(`/library/report/monthly-collection?${addUrl}`);
};

export const libraryDueSummary = async (addUrl = "") => {
  return await api.get(`/library/report/due-summary?${addUrl}`);
};

export const librarySeatOccupancy = async (addUrl = "") => {
  return await api.get(`/library/report/seat-occupancy?${addUrl}`);
};

export const libraryShiftWiseStudents = async (addUrl = "") => {
  return await api.get(`/library/report/shift-wise?${addUrl}`);
};
